import { Pagination } from "@CommonTypes/backend/pagination";
import { OneStoreView } from "@CommonTypes/merchflow/OneStoreView";

export const RouteGetMerchflowStoreProp_storePropagationId_ =
  "/merchflow/store-prop/:storePropagationId";

export type ResponseGetMerchflowStoreProp_storePropagationId_ = Pagination<OneStoreView>;
